// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { setCredentials, logout as logoutAction, setLoading, setError } from '../store/slices/authSlice';
// import { authService } from '../services/auth.service';

// export const useAuth = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { user, isAuthenticated, loading, error } = useSelector((state) => state.auth);

//     const login = async (credentials) => {
//         try {
//             dispatch(setLoading(true));
//             const res = await authService.login(credentials);
//             localStorage.setItem('authToken', res.token);
//             dispatch(setCredentials({ user: res.user, token: res.token }));
//             navigate('/');
//             return { success: true };
//         } catch (err) {
//             dispatch(setError(err.message));
//             return { success: false, error: err.message };
//         } finally {
//             dispatch(setLoading(false));
//         }
//     };

//     const register = async (data) => {
//         try {
//             dispatch(setLoading(true));
//             const res = await authService.register(data);
//             localStorage.setItem('authToken', res.token);
//             dispatch(setCredentials({ user: res.user, token: res.token }));
//             navigate('/');
//             return { success: true };
//         } catch (err) {
//             dispatch(setError(err.message));
//             return { success: false, error: err.message };
//         } finally {
//             dispatch(setLoading(false));
//         }
//     };

//     const logout = async () => {
//         try { await authService.logout(); }
//         finally {
//             localStorage.removeItem('authToken');
//             dispatch(logoutAction());
//             navigate('/login');
//         }
//     };

//     return { user, isAuthenticated, loading, error, login, register, logout };
// };
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCredentials, logout as logoutAction, setLoading, setError } from '../store/slices/authSlice';
import { authService } from '../services/auth.service';

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isAuthenticated, loading, error } = useSelector((state) => state.auth);

  const login = async (credentials) => {
    try {
      dispatch(setLoading(true));
      const res = await authService.login(credentials);
      localStorage.setItem('authToken', res.token);
      dispatch(setCredentials({ user: res.user, token: res.token }));
      navigate('/');
      return { success: true };
    } catch (err) {
      dispatch(setError(err.message));
      return { success: false, error: err.message };
    } finally {
      dispatch(setLoading(false));
    }
  };

  const register = async (data) => {
    try {
      dispatch(setLoading(true));
      const res = await authService.register(data);
      localStorage.setItem('authToken', res.token);
      dispatch(setCredentials({ user: res.user, token: res.token }));
      navigate('/');
      return { success: true };
    } catch (err) {
      dispatch(setError(err.message));
      return { success: false, error: err.message };
    } finally {
      dispatch(setLoading(false));
    }
  };

  const logout = () => {
    // ── Instant logout — clear state first, API call in background ──
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    dispatch(logoutAction());
    navigate('/login');

    // Fire-and-forget — don't await, don't block UI
    authService.logout().catch(() => {});
  };

  return { user, isAuthenticated, loading, error, login, register, logout };
};
